import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsWalkNormalXsmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M7.5 11.5h-2v1h2z" />
        <path d="M15 8.06a1.646 1.646 0 00-1.22-.56h-1.41L7.65 4.99l-.42-.7a1.65 1.65 0 00-2.97.33l-.13.4A1.478 1.478 0 003 4.5 1.5 1.5 0 001.5 6v3.59A1.5 1.5 0 00.5 11 1.45 1.45 0 002 12.5h2.5v-1H2a.452.452 0 01-.5-.5.5.5 0 01.5-.5h5.5v-1h-5V6a.5.5 0 011 0v.5h1.19l.52-1.56a.668.668 0 011.16-.13l.57.94.65.35-.58 1.09.88.47.58-1.1.95.51-.58 1.09.88.47.58-1.09.95.5-.59 1.1.88.47.59-1.11h1.65a.644.644 0 01.48.23.84.84 0 01.22.56.959.959 0 01-.28.69l-.49.47a3.718 3.718 0 01-2.21 1.02v1.01a4.736 4.736 0 002.9-1.31l.5-.47c.37-.376.579-.882.58-1.41 0-.456-.17-.895-.48-1.23z" />
        <path d="M10.5 11.5h-2v1h2z" />
      </g>
    </svg>
  )
);
SvgSportsWalkNormalXsmall.defaultProps = {
  color: 'currentColor',
  size: 16,
  title: undefined,
  titleId: undefined
};
SvgSportsWalkNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsWalkNormalXsmall;
